export default async function(response: Response) {
  let json = await response.json()

  return Object.values(json.items).reduce((acc, item) => {
    return (acc as any).concat(item)
  }, [])
}
